

<!-- <div class="container headerComponent min-height-header">
  <div class="btn-group">
      <button type="button" class="btn btn-danger">Action</button>
      <button type="button" id="dropdownMenuButton" class="btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="#">Action</a>
        <a class="dropdown-item" href="#">Another action</a>
        <a class="dropdown-item" href="#">Something else here</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#">Separated link</a>
      </div>
    </div> -->
<!-- <app-header ></app-header> -->
    <router-outlet></router-outlet>

    <!-- <div class="accordions">
      <div class="accordion">
        <h2>Standard accordion</h2>
        <ngx-accordion>
          <ngx-accordion-group>
            <ngx-accordion-group-element>
              <fa-icon [icon]="faAppleAlt"></fa-icon> 
    
              Fruits
            </ngx-accordion-group-element>
            <ngx-accordion-group-child> Banana</ngx-accordion-group-child>
            <ngx-accordion-group-child> Orange</ngx-accordion-group-child>
          </ngx-accordion-group>
        </ngx-accordion>
      </div>
    </div> -->
    <!-- <div (click)="disableClick($event)"></div> -->
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fcba13" type="ball-atom" [fullScreen]="true">
<div style="color: white;" *ngIf="isConfirming">Please wait order is confirming..</div>

    </ngx-spinner>

